import {
    accessToken as getAccessToken,
    qrcode,
    init,
    deleteToken,
    authSuite,
    companyPermissions,
    agentConfig as getAgentConfig,
    weworkWorkbenchAuth,
    setGuide,
    getComponyList,
} from 'services/auth'
import {router} from 'umi'
import {globalActionsType} from 'utils/dva'
// import {notification} from 'antd'
import {setDvaNamespaceMap} from 'hooks'
import createModel from 'utils/model'
import {hzAgentConfigInit, isWxwork, isWx} from 'utils/wx'
import {stringify} from 'qs'

let isLogoutClick = false

function setIsLogoutClick(flag) {
    isLogoutClick = !!flag
}

async function getLogoutUrl({error, useJumpUrl}) {
    let url = `/login`
    try {
        if (useJumpUrl) {
            const jumpUrl = window.encodeURIComponent(
                window.location.href.replace(window.location.origin, ''),
            )

            url = `/login?jumpUrl=${jumpUrl}`
        } else if (error) {
            const res = await error.response.json()

            if (res?.meta?.display) {
                url = `/login-failure?${stringify({message: res?.meta?.message})}`
            }
            // else if (meta.code === 101024) {
            //     if (isWxwork() || isWx()) {
            //         url = '/app-expire'
            //     } else {
            //         notification.error({
            //             message: '温馨提示:',
            //             description: meta.message,
            //         })
            //     }
            // }
        }
    } catch (e) {
        console.info(e)
    }

    return url
}

export default createModel({
    namespace: 'auth',

    state: {
        initData: {},
        remaining_day: null,
        wxConfig: {},
        hasGuide: false,
    },

    effects: {
        *init({payload}, {call, put}) {
            const {data} = yield call(init, payload)

            yield put({
                type: 'immerSet',
                payload: {
                    initData: data,
                },
            })

            return data
        },

        *qrcode({payload}, {call}) {
            const {data} = yield call(qrcode, payload)

            return data
        },

        *agentConfig(xx, {call, put}) {
            const {data} = yield call(getAgentConfig, {
                url: window.location.href.split('#')[0],
                with_config: isWxwork() || isWx() ? 1 : undefined,
            })

            yield hzAgentConfigInit({
                configOption: {
                    beta: true,
                    debug: false,
                    appId: data?.config?.corp_id,
                    nonceStr: data?.config?.nonce_str,
                    signature: data?.config?.signature,
                    timestamp: data?.config?.timestamp,
                    jsApiList: ['agentConfig'],
                },
                agentConfigOption: {
                    corpid: data.corp_id,
                    agentid: data.agent_id,
                    nonceStr: data.nonce_str,
                    signature: data.signature,
                    timestamp: data.timestamp,
                    jsApiList: [''],
                },
            })

            yield put({
                type: 'immerSet',
                payload: {
                    wxConfig: data.remaining_day,
                },
            })
        },

        *setGuide({payload}, {call}) {
            return yield call(setGuide, payload)
        },

        *accessToken({payload}, {call}) {
            return yield call(getAccessToken, payload)
        },

        *weworkWorkbenchAuth({payload}, {call}) {
            return yield call(weworkWorkbenchAuth, payload)
        },

        *companyPermissions({payload}, {call, put}) {
            const {data} = yield call(companyPermissions, payload)

            if (data) {
                yield put({
                    type: 'immerSet',
                    payload: {
                        remaining_day: data.remaining_day,
                    },
                })
            } else {
                yield put({
                    type: 'immerSet',
                    payload: {
                        remaining_day: -1,
                    },
                })
            }

            return data
        },

        *authSuite({payload}, {call}) {
            return yield call(authSuite, payload)
        },

        *logout({payload = {}}, {call, put, select}) {
            if (isLogoutClick) {
                return
            }

            setIsLogoutClick(true)

            const {useJumpUrl = false, error} = payload

            try {
                const {accessToken} = yield select(({base}) => ({
                    accessToken: base.accessToken,
                }))

                if (accessToken) {
                    yield call(deleteToken)
                }
            } finally {
                const url = yield call(getLogoutUrl, {error, useJumpUrl})

                router.push(url)

                yield put({
                    type: 'base/immerRemoveAccessToken',
                })

                yield put({
                    type: globalActionsType.logout,
                })

                setDvaNamespaceMap({})

                setIsLogoutClick(false)
            }
        },

        *getComponyList({payload}, {call}) {
            return yield call(getComponyList, payload)
        },
    },
})
